/** @jsx builderX.jsx */

import {builderX, Image, Sprite, Text} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite position={[0, 0]} name='winPanel'>
        <Image name='bg' src='win_ui_wide_square'/>
        <Text
            position={[286, 72]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 170,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='fieldText'
            localeTextID=''
            text='$24000.00'
        />
        <Text
            position={[626, 274]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 60,
                fontStyle: 'normal',
                fill: '#FFD200',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={313}
            name='label'
            localeTextID=''
            text='WIN'
        />
    </Sprite>
);
